import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {store, persistor} from './redux/store';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {service, factories} from 'powerbi-client';

// Warm up Power BI in a hidden iframe as soon as the app is idle, so its
// scripts are already cached when the report page embeds a report.
const preloadPowerBi = () => {
	try {
		const powerbi = new service.Service(
			factories.hpmFactory,
			factories.wpmpFactory,
			factories.routerFactory,
		);
		powerbi.preload({type: 'preload', embedUrl: 'https://app.powerbi.com/reportEmbed'});
	} catch (e) {
		// preload is only an optimisation
	}
};
const schedulePreload = () =>
	'requestIdleCallback' in window
		? window.requestIdleCallback(preloadPowerBi, {timeout: 2000})
		: setTimeout(preloadPowerBi, 500);
// Skip it when the app opens directly on a reports page: that page already
// warms up Power BI with powerbi.bootstrap(), and a second Power BI iframe
// loading at the same time would only compete with it for bandwidth and CPU.
const opensOnReports = window.location.pathname.toLowerCase().startsWith('/reports');
if (!opensOnReports) {
	if (document.readyState === 'complete') schedulePreload();
	else window.addEventListener('load', schedulePreload, {once: true});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate
				loading={null}
				persistor={persistor}
			>
				<GoogleOAuthProvider clientId='572745194466-vlnnffp6pcb94n9i7q5i0v4i7trh59oe.apps.googleusercontent.com'>
					<App />
				</GoogleOAuthProvider>
			</PersistGate>
		</Provider>
	</React.StrictMode>
);

reportWebVitals();
